module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-card-submit-review.aa5ea25b.png";